import { useRegisterAgentContext } from "@/features/agent-chat/context/AgentPageContext"
import {
  MASTER_DATA_ROUTES,
  type MasterDataEntity,
} from "./masterDataAgentTargets"

/**
 * Tell the agent which master-data screen the user is on and which record is
 * selected, so "tell me about this one" resolves without asking the user to
 * repeat an id. `selected_id` is omitted rather than sent as null: an absent key
 * reads as "nothing selected", where a null could be mistaken for a record.
 */
export function useRegisterMasterDataAgentContext(
  entity: MasterDataEntity,
  selectedId: string | null,
): void {
  useRegisterAgentContext({
    route: MASTER_DATA_ROUTES[entity],
    entities: {
      mc_entity: entity,
      ...(selectedId ? { selected_id: selectedId } : {}),
    },
  })
}
